import * as React from 'react';
import { connect } from 'react-redux';

import { resetSuccessMessage } from '../../actions/users';

import Loader from '~/common/components/Loader';
import UserProfileForm from '../../components/settings/UserProfileForm';
import { forcePasswordChange } from 'apps/shared/actions/auth';


class UserProfile extends React.Component<any, any> {
  componentDidMount = () => {
    const { dispatch } = this.props;
    dispatch(resetSuccessMessage());
  };

  onSubmit = (data) => {
    const { dispatch, currentUser } = this.props;
    console.log(data);

    // TODO: Show confirmation or something
    // dispatch(updateUser(currentUser.id, data));
    dispatch(forcePasswordChange(
      data.username, data.password, data.newPassword, true
    ));
  };

  render() {
    const { currentUser, user } = this.props;

    if (!currentUser) {
      return (
        <Loader />
      );
    }

    return (
      <UserProfileForm
        user={currentUser}
        error={user.errorMessage}
        success={user.successMessage}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.shared.auth.currentUser,
    user: state.shared.users.ui,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile) as any;
